<div class="multi-select" (mouseleave)="showDropDown && outSelectValue()">
  <input type="text" autocomplete="off" (focus)="focusIn($event.target.value)" class="drop-toggle btn flat" [(ngModel)]="selectedValue"
    (click)="showDropDown=!showDropDown" [ngClass]="{'active': showDropDown}"
    [id]="idInput" [disabled]="disabledInput" [maxlength]="maxlengthInput"
    (focusout)="focusOunt()">
  <div class="drop-show " [ngClass]="{'scroll-box': lstItem.length >=10}" *ngIf="showDropDown">
    <div *ngFor="let it of lstItem; index as i">
      <label (click)="selected(it)" [ngClass]="{'active': it.active}">
        {{it.value}}
      </label>
    </div>
  </div>
</div>
<ng-template #PopInpAssistant>
  <app-pop-inp-assistant [HTItem]="inputObj" (eventClosePop)="ClosePop0401($event)"></app-pop-inp-assistant>
</ng-template>